import React, { useState } from "react";
import {
  Popper,
  ClickAwayListener,
  Paper,
  TextField,
  IconButton,
  Icon,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

export default function MultiSelectPicker({
  title = "Select options",
  options = [],
  value = [],
  onChange,
  disabled = false,
  placeholder = "",
  width = 380,
  getOptionDisabled = () => false, // external disable logic
}) {
  const [dropdownAnchor, setDropdownAnchor] = useState(null);
  const [open, setOpen] = useState(false);

  const handleToggle = (e) => {
    if (disabled) return;
    setDropdownAnchor(e.currentTarget);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setDropdownAnchor(null);
  };

  return (
    <div style={{ width: "100%", display: "flex" }}>
      <div
        style={{
          position: "relative",
          flex: 1,
          borderBottom: "1px solid #949494",
          paddingRight: "30px",
          lineHeight: "24px",
          minHeight: "24px",
          display: "flex",
          alignItems: "center",
          minWidth: 0,
        }}
      >
        {/* Display selected labels */}
        <span
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            display: "block",
            flex: 1,
            color: "#636336",
            fontSize: "13px",
            fontWeight: "200",
          }}
          title={value.length > 0 ? value.map((v) => v.label).join(", ") : ""}
        >
          {value.length > 0 ? value.map((v) => v.label).join(", ") : "\u00A0"}
        </span>

        {/* Dropdown button */}
        <IconButton
          style={{
            position: "absolute",
            bottom: "-1px",
            right: "0px",
            height: "32px",
            width: "32px",
            padding: "0px",
            background: "transparent",
          }}
          disabled={disabled}
          onClick={handleToggle}
        >
          <Icon style={{ fontSize: "20px" }}>arrow_drop_down</Icon>
        </IconButton>
      </div>

      {/* Popper with Autocomplete */}
      <Popper
        open={open}
        anchorEl={dropdownAnchor}
        placement="bottom"
        modifiers={[
          {
            name: "offset",
            options: { offset: [0, 4] },
          },
        ]}
        style={{ width }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Paper elevation={3} style={{ padding: 8, minWidth: 200 }}>
            <div style={{ display: "flex" }}>
              <div style={{ flex: "1", fontWeight: "600", lineHeight: "30px" }}>
                {title}
              </div>
              <div
                onClick={handleClose}
                style={{ margin: "5px", cursor: "pointer" }}
              >
                <Icon
                  style={{
                    color: "#EF7C01",
                    lineHeight: "1",
                    fontSize: "28px",
                  }}
                >
                  arrow_forward
                </Icon>
              </div>
            </div>

            <Autocomplete
              multiple
              disableCloseOnSelect
              disabled={disabled}
              options={options}
              getOptionLabel={(option) => option.label}
              getOptionDisabled={
                (option) =>
                  value.some((v) => v.value === option.value) ||
                  getOptionDisabled(option) // combine both rules
              }
              value={value}
              onChange={(e, v) => onChange(v)}
              style={{ width: "100%" }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={placeholder}
                  className="autocomplete-text-field-class"
                />
              )}
            />
          </Paper>
        </ClickAwayListener>
      </Popper>
    </div>
  );
}
